import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
// eslint-disable-next-line import/no-unresolved, import/extensions
import Icon from '../../../common/containers/icon';
import Badge from './badge';
import { getSeverityColorClass } from './qualityAgentHelpers';

// Check settings row component - for the settings modal
const CheckSettingsRow = _ref => {
  let checkId = _ref.checkId,
    check = _ref.check,
    onToggle = _ref.onToggle,
    onDelete = _ref.onDelete;
  const isEnabled = check.enabled !== false; // default to true
  // Only explicitly true is default; prevents locking users out of deleting custom checks
  const isDefault = check.isDefault === true;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isConfirmModalOpen = _useState2[0],
    setIsConfirmModalOpen = _useState2[1];
  const handleDeleteClick = () => {
    setIsConfirmModalOpen(true);
  };
  const handleConfirmDelete = () => {
    setIsConfirmModalOpen(false);
    onDelete(checkId);
  };
  const handleCancelDelete = () => {
    setIsConfirmModalOpen(false);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom py-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center flex-wrap",
    style: {
      gap: 8
    }
  }, isDefault && /*#__PURE__*/React.createElement(Badge, {
    pill: true,
    style: {
      backgroundColor: '#6c757d',
      color: 'white',
      padding: '4px 10px',
      fontSize: '0.75rem'
    }
  }, "Recommended"), /*#__PURE__*/React.createElement("span", {
    className: "fw-medium"
  }, check.description || checkId)), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center",
    style: {
      marginLeft: 12
    }
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn p-0 border-0 bg-transparent",
    style: {
      width: 28,
      display: 'flex',
      justifyContent: 'center'
    },
    disabled: isDefault,
    onClick: !isDefault ? handleDeleteClick : undefined,
    "aria-label": "Delete ".concat(check.description || checkId)
  }, !isDefault && /*#__PURE__*/React.createElement("span", {
    className: "text-danger",
    style: {
      cursor: 'pointer'
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-check form-switch mb-0"
  }, /*#__PURE__*/React.createElement("input", {
    className: "form-check-input",
    type: "checkbox",
    role: "switch",
    id: "check-toggle-".concat(checkId),
    checked: isEnabled,
    onChange: () => onToggle(checkId, !isEnabled),
    style: {
      cursor: 'pointer',
      width: '2.5em',
      height: '1.25em'
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "mt-1 ms-0",
    style: {
      fontSize: '0.85rem'
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-muted text-capitalize"
  }, check.category || 'general'), /*#__PURE__*/React.createElement("span", {
    className: "text-muted mx-2"
  }, "\u2022"), /*#__PURE__*/React.createElement("span", {
    className: "text-capitalize ".concat(getSeverityColorClass(check.severity))
  }, check.severity || 'low')), /*#__PURE__*/React.createElement(Modal, {
    isOpen: isConfirmModalOpen,
    toggle: handleCancelDelete,
    centered: true,
    "aria-labelledby": "delete-check-confirm-title-".concat(checkId),
    "aria-describedby": "delete-check-confirm-description-".concat(checkId)
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: handleCancelDelete,
    id: "delete-check-confirm-title-".concat(checkId)
  }, "Delete Check"), /*#__PURE__*/React.createElement(ModalBody, {
    id: "delete-check-confirm-description-".concat(checkId)
  }, "Are you sure you want to delete this check? This action cannot be undone."), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: handleCancelDelete,
    type: "button"
  }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
    color: "danger",
    onClick: handleConfirmDelete,
    type: "button"
  }, "Delete"))));
};
CheckSettingsRow.propTypes = {
  checkId: PropTypes.string.isRequired,
  check: PropTypes.shape({
    description: PropTypes.string,
    category: PropTypes.string,
    severity: PropTypes.string,
    enabled: PropTypes.bool,
    isDefault: PropTypes.bool
  }).isRequired,
  onToggle: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};
export default CheckSettingsRow;